import React, { useCallback } from 'react'
import { Field } from 'formik'
import FormField from 'components/form-components/Contact/FormField'
import FormTextArea from 'components/form-components/Contact/FormTextArea'
import FormImage from 'components/form-components/Contact/FormImage/index'
import PropTypes from 'prop-types'
import styled, { ThemeProvider } from 'styled-components'
import { FormWrap, LongColumn, contactFormTheme } from 'styles/contact-form'
import FormStatus from './FormStatus'
import { ButtonBase } from 'components/Button'
import ReasonsSelect from './ReasonsSelect'

const Form = styled(FormWrap)`
  padding: 30px 0 0;
  width: 670px;
`

const Label = styled.label`
  display: inline-block;
  width: 100%;
  font-size: 14px;
  line-height: 20px;
  font-weight: 700;
  margin-bottom: 12px;
`

const ButtonSubmit = styled(ButtonBase)`
  && {
    width: 100%;
    background-color: rgba(0, 0, 0, 1);
    border-radius: 100px;
    color: rgba(255, 255, 255, 1);
    font-size: 16px;
    font-weight: 600;
    opacity: 1;
    cursor: pointer;
    @media (hover: hover) {
      &:hover {
        opacity: 0.7;
      }
    }
    &:disabled {
      background-color: rgba(232, 236, 243, 1);
      border: 1px solid transparent;
      color: rgba(0, 0, 0, 1);
      cursor: not-allowed;
    }
  }
`

const ButtonWrapper = styled.div`
  width: 100%;
  margin: 18px auto 0;
`

const FieldForm = styled(LongColumn)`
  margin-bottom: 24px;
`

const translations = {
  nameLabel: 'Full name',
  namePlaceholder: 'Enter Your Name',
  emailLabel: 'Email',
  emailPlaceholder: 'Enter your email address',
  reasonLabel: 'Reason',
  reasonPlaceholder: 'Select from the drop down menu',
  subjectLabel: 'Subject',
  subjectPlaceholder: 'Enter your subject',
  messageLabel: 'Message',
  messagePlaceholder: 'Enter your message here',
  uploadLabel: 'Upload attachments',
  subbmitButton: 'Submit message',
}

const ContactForm = ({
  handleSubmit,
  isValid,
  dirty,
  status,
  isSubmitting,
  setFieldValue,
}) => {
  const handleAttach = useCallback(
    file => setFieldValue('attachment', file, false),
    []
  )
  return (
    <ThemeProvider theme={contactFormTheme}>
      <Form onSubmit={handleSubmit}>
        <FieldForm>
          <Label>{translations.nameLabel}</Label>
          <Field
            name="name"
            type="text"
            placeholder={translations.namePlaceholder}
            noMargin={true}
            component={FormField}
          />
        </FieldForm>
        <FieldForm>
          <Label>{translations.emailLabel}</Label>
          <Field
            name="email"
            type="email"
            placeholder={translations.emailPlaceholder}
            noMargin={true}
            component={FormField}
          />
        </FieldForm>
        <FieldForm>
          <Label>{translations.reasonLabel}</Label>
          <Field
            name="reason"
            placeholder={translations.reasonPlaceholder}
            component={ReasonsSelect}
          />
        </FieldForm>
        <FieldForm>
          <Label>{translations.subjectLabel}</Label>
          <Field
            name="subject"
            type="text"
            placeholder={translations.subjectPlaceholder}
            noMargin={true}
            component={FormField}
          />
        </FieldForm>
        <FieldForm>
          <Label>{translations.messageLabel}</Label>
          <Field
            name="message"
            placeholder={translations.messagePlaceholder}
            noMargin={true}
            component={FormTextArea}
          />
        </FieldForm>
        <FieldForm>
          <Label>{translations.uploadLabel}</Label>
          <Field
            name="attachment"
            onChange={handleAttach}
            noMargin={true}
            isRemoveAllActive={true}
            isMultiple={false}
            component={FormImage}
          />
        </FieldForm>
        <ButtonWrapper>
          <ButtonSubmit
            onClick={handleSubmit}
            type="submit"
            disabled={!isValid || !dirty || isSubmitting}
          >
            {translations.subbmitButton}
          </ButtonSubmit>
        </ButtonWrapper>
        <LongColumn>
          <FormStatus status={status} dirty={dirty} />
        </LongColumn>
      </Form>
    </ThemeProvider>
  )
}

ContactForm.propTypes = {
  handleSubmit: PropTypes.func,
  setFieldValue: PropTypes.func,
  isValid: PropTypes.bool,
  dirty: PropTypes.bool,
  status: PropTypes.any,
  isSubmitting: PropTypes.bool,
}

export default ContactForm
